export enum AlternativeByType {
    Generic = 1,
    Ingredient = 2,
}
